import axios from "axios";
import Storage from "@/utils/storage";
import config from "@/config/index";

const service = axios.create({
  baseURL: config.supportApiBaseUrl,
  timeout: config.timeout,
});

service.interceptors.request.use(
  (config) => {
    const identityToken = Storage.get("identityToken");
    const authHeader = "Bearer " + identityToken;
    config.headers.common["Authorization"] = authHeader;
    // if (!isFormData(config.data)) {
    //   if (identityToken) {
    //     if (config.data) {
    //       if (config.data && config.data.length > 0) {
    //         config.data += `&identity_token=${identityToken}`;
    //       } else {
    //         config.data += `identity_token=${identityToken}`;
    //       }
    //     } else {
    //       config.data = `identity_token=${identityToken}`;
    //     }
    //   }
    // }
    return config;
  },
  (error) => Promise.reject(error)
);

export default service;
